import { CIInfoIcon } from 'ccs-ui-components';
import yaml from 'js-yaml';
import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { swaggerFileType } from '../../constants';
import classes from './DragAndDrop.module.scss';

const arrayBufferToString = (exportedPrivateKey: any) => {
  const byteArray = new Uint8Array(exportedPrivateKey);
  let byteString = '';
  byteArray.forEach((data) => {
    byteString += String.fromCodePoint(data);
  });
  return byteString;
};

export const MyDropzone = ({ updateFileData }: any) => {
  const onDrop = useCallback((acceptedFiles: any[]) => {
    const importedFile = acceptedFiles[0];
    const reader = new FileReader();
    const extensionArr = importedFile.name.split('.');
    const extension = extensionArr[extensionArr.length - 1];
    if (extension === swaggerFileType.JSON || extension === swaggerFileType.YML || extension === swaggerFileType.YAML) {
      reader.onload = () => {
        try {
          const binaryStr = reader.result;
          let data;
          if (extension === swaggerFileType.JSON) {
            data = JSON.parse(arrayBufferToString(binaryStr));
          }
          if (extension === swaggerFileType.YML || extension === swaggerFileType.YAML) {
            data = (yaml.load(arrayBufferToString(binaryStr)));
          }
          updateFileData({ data, fileName: importedFile.name, status: true, validationError: false });
        } catch (error) {
          updateFileData({ validationError: true });
        }
      };
    } else {
      updateFileData({ data: {}, fileName: importedFile.name, status: false, validationError: false });
    }
    reader.readAsArrayBuffer(importedFile);
  }, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop
  });
  const { t: translate } = useTranslation();
  return (
    <div {...getRootProps({ className: classes.dropzone })}>
      <input data-testid="drop-input" accept="application/json" {...getInputProps()} />
      <p className={classes['drag-drop-msg-text']}>{translate('drag_and_drop.txt_desc')}<CIInfoIcon iconTxt={String(translate('service_details_form_component.autofill_info_bubble'))} /></p>
      <p className={classes['drag-drop-browse']}>{translate('drag_and_drop.txt_drag_drop')} <span className={classes['browse-file']}>{translate('drag_and_drop.txt_browse')}</span></p>
      <p className={classes['supported-file']}>{translate('drag_and_drop.txt_type')}</p>
    </div>
  );
};
